let _store

export const initHandler = (store) => {
  if (!navigator || !navigator.serviceWorker) return

  _store = store

  document.addEventListener('swUpdated', e => _store.dispatch('swUpdate/newUpdate', e.detail))

  navigator.serviceWorker.addEventListener(
    'controllerchange', () => {
      if ((_store || {}).state.swUpdate.refreshing) return
      _store.dispatch('swUpdate/startReload')
      window.location.reload()
    }
  )
}

export const postHandler = () => {
  (_store || {}).dispatch('swUpdate/skipWaiting')
}
